import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectSelectedProjectId } from 'store/projects/selectors/projectsSelectors';
import { patchAddSubcontractor } from '../services/patchAddSubctontractor.service';

export const addSubcontractorExistingBusiness = createAsyncThunk(
  'organizationCharts/addSubcontractorExistingBusiness',
  async (
    {
      targetOrganizationChartItemId,
      subcontractorBusinessId,
      subcontractorBusinessName,
    },
    { getState }
  ) => {
    const selectedProjectId = selectSelectedProjectId(getState());

    const response = await patchAddSubcontractor(
      selectedProjectId,
      targetOrganizationChartItemId,
      subcontractorBusinessId,
      subcontractorBusinessName
    );

    return response;
  }
);
